import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import ItemMaster from '@/pages/ItemMaster';
import SupplierMaster from '@/pages/SupplierMaster';
import Projects from '@/pages/Projects';
import StockReceipt from '@/pages/StockReceipt';
import StockIssue from '@/pages/StockIssue';
import CurrentStock from '@/pages/CurrentStock';
import Reports from '@/pages/Reports';
import ProjectEntries from '@/pages/ProjectEntries';
import ProjectCommercials from '@/pages/ProjectCommercials';
import TransactionHistory from '@/pages/TransactionHistory';
import MaterialReconciliation from '@/pages/MaterialReconciliation';
import TurnedParts from '@/pages/TurnedParts';
import Backup from '@/pages/Backup';
import DashboardLayout from '@/components/DashboardLayout';
import '@/App.css';

function ProtectedRoute({ children }) {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/project-commercials" element={<ProjectCommercials />} />
                    <Route path="/items" element={<ItemMaster />} />
                    <Route path="/suppliers" element={<SupplierMaster />} />
                    <Route path="/projects" element={<Projects />} />
                    <Route path="/stock-receipt" element={<StockReceipt />} />
                    <Route path="/stock-issue" element={<StockIssue />} />
                    <Route path="/current-stock" element={<CurrentStock />} />
                    <Route path="/material-reconciliation" element={<MaterialReconciliation />} />
                    <Route path="/turned-parts" element={<TurnedParts />} />
                    <Route path="/reports" element={<Reports />} />
                    <Route path="/project-entries" element={<ProjectEntries />} />
                    <Route path="/history" element={<TransactionHistory />} />
                    <Route path="/backup" element={<Backup />} />
                  </Routes>
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;